export default {
  getSubscription(state, data) {
    state.subscription.list = data;
  }
};
